import { ChangeDetectorRef, Component, DestroyRef, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import * as _ from 'underscore';
import { PrinterDTO } from '../../../modules/estimates/models/printer-dto';
import { BinTagService } from '../../../modules/estimates/services/bin-tag.service';


@Component({
  selector: 'printer-selector',
  templateUrl: './printer-selector.component.html',
  styleUrls: ['./printer-selector.component.scss']
})
export class PrinterSelectorComponent implements OnInit {

  @Input() printer: PrinterDTO;
  @Output() printerChange: EventEmitter<PrinterDTO> = new EventEmitter<PrinterDTO>();

  @Output() selectionChanged: EventEmitter<PrinterDTO> = new EventEmitter<PrinterDTO>();

  @Input() isRequired: boolean = false;
  public searchValue: string = "";
  public isLoading = true;

  public objList: PrinterDTO[] = [];
  public allObj: PrinterDTO[] = [];

  private destroyRef = inject(DestroyRef);
  
  constructor(
    private binTagService: BinTagService,
    private changeDetRef: ChangeDetectorRef,
  ) { }

  ngOnInit() {
    this.binTagService.getPrinters().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(r => {
      this.allObj = r.filter(x => x.isActive);
      this.filter();
      this.isLoading = false;
      this.changeDetRef.markForCheck();
    })
  }

  onSelectChange(){
    
    this.selectionChanged.emit(this.printer);
  }

  filter() {

    let filterList = this.allObj.filter(x => this.searchValue === ''
                                              || x.name.toLowerCase().includes(this.searchValue.toLowerCase())
                                              );
    if (filterList.length > 20)
      this.objList = [];
    else
      this.objList = _.sortBy(filterList, 'name');

    // resolve incoming selection (possibly a stub with just an id) to the full object from allObj
    // and ensure it's included in the visible list
    if (this.printer && this.printer.id !== 0) {
      let fullPrinter = this.allObj.filter(x => x.id == this.printer.id)[0];
      if (fullPrinter) {
        this.printer = fullPrinter;
        if (this.objList.filter(x => x.id == fullPrinter.id).length === 0) {
          this.objList.push(fullPrinter);
        }
      }
    }

    if (!this.printer || !this.objList.find(x => x.id == this.printer.id)) {
      this.printer = this.objList[0];
    }
    this.selectionChanged.emit(this.printer);
  }

}
